import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';

import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';

import { getFormByCurrentLanguage } from 'utils/form-localization/formLocalization';

import { BookInfoList } from 'components';

import useStyles from './styles';

const BookingInformation = ({ data, form }) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();
  const selectedLanguage = i18n.language;

  const values = form.values;

  const dates = values.dates;
  const startDate =
    dates && dates.startDate
      ? moment(dates.startDate).format('DD.MM.YYYY')
      : null;
  const endDate =
    dates && dates.endDate ? moment(dates.endDate).format('DD.MM.YYYY') : null;

  const startingDate = values.startingDate
    ? moment(values.startingDate).format('DD.MM.YYYY')
    : null;
  const startTime = values.startTime
    ? moment(values.startTime.startTime, 'hh:mm').format('H:mm')
    : null;
  const duration = values.startTime ? values.startTime.duration : null;
  const timeType = values.startTime ? values.startTime.timeType : null;
  const generalForm = data.generalForm;
  const generalFormNorwegian = data['generalForm-Norwegian'];
  const descriptionForm = data.descriptionForm;
  const descriptionFormNorwegian = data['descriptionForm-Norwegian'];
  const checkIn = generalForm.checkInAfter
    ? moment(generalForm.checkInAfter).format('H:mm')
    : null;
  const checkOut = generalForm.checkOutBefore
    ? moment(generalForm.checkOutBefore).format('H:mm')
    : null;

  const currentLanguageGeneralForm = getFormByCurrentLanguage(
    selectedLanguage,
    generalForm,
    generalFormNorwegian
  );

  return (
    <>
      <div
        className={classes.photo}
        style={{
          backgroundImage: `url(${generalForm.coverPhoto.image})`
        }}
      >
        {''}
      </div>
      <Typography variant="h2" classes={{ root: classes.title }}>
        {currentLanguageGeneralForm.title}
      </Typography>
      <Typography variant="body1" classes={{ root: classes.description }}>
        {
          getFormByCurrentLanguage(
            selectedLanguage,
            descriptionForm,
            descriptionFormNorwegian
          ).overview
        }
      </Typography>

      {currentLanguageGeneralForm.location &&
        !!currentLanguageGeneralForm.location.length && (
          <div className={classes.location}>
            <LocationOnOutlinedIcon className={classes.locationIcon} />
            <Typography variant="body1" className={classes.locationText}>
              {currentLanguageGeneralForm.location}
            </Typography>
          </div>
        )}

      {currentLanguageGeneralForm.startingPoint &&
        !!currentLanguageGeneralForm.startingPoint.length && (
          <div className={classes.location}>
            <LocationOnOutlinedIcon className={classes.locationIcon} />
            <Typography variant="body1" className={classes.locationText}>
              {currentLanguageGeneralForm.startingPoint}
            </Typography>
          </div>
        )}

      {((startDate && endDate) || startingDate) && (
        <div className={classes.datesWrapper}>
          <Typography variant="h2" classes={{ root: classes.infoDatesTitle }}>
            {t('Your dates')}
          </Typography>

          {startDate && endDate && (
            <Typography variant="h3" classes={{ root: classes.datesItem }}>
              <span>{t('From – To')}:</span>
              <span className={classes.infoValue}>
                {startDate} – {endDate}
              </span>
            </Typography>
          )}
          {checkIn && (
            <>
              <Typography variant="h3" classes={{ root: classes.datesItem }}>
                <span>{t('Check-in')}:</span>
                <span className={classes.infoValue}>{checkIn}</span>
              </Typography>
              <Typography variant="h3" classes={{ root: classes.datesItem }}>
                <span>{t('Check-out')}:</span>
                <span className={classes.infoValue}>{checkOut}</span>
              </Typography>
            </>
          )}

          {startingDate && (
            <Typography variant="h3" classes={{ root: classes.datesItem }}>
              <span>{t('Starting date')}:</span>
              <span className={classes.infoValue}>{startingDate}</span>
            </Typography>
          )}
          {startTime && (
            <Typography variant="h3" classes={{ root: classes.datesItem }}>
              <span>{t('Start time')}:</span>
              <span className={classes.infoValue}>{startTime}</span>
            </Typography>
          )}
          {duration && (
            <Typography variant="h3" classes={{ root: classes.datesItem }}>
              <span>{t('Duration')}:</span>
              <span className={classes.infoValue}>
                {duration} {t(timeType)}
              </span>
            </Typography>
          )}
        </div>
      )}

      <BookInfoList
        activity={data}
        currency={values.currency || 'NOK'}
        isOverview={false}
      />
    </>
  );
};

export default BookingInformation;
